/** Плейсхолдер для решений без своей картинки в админке (public/images/vendors/default.png) */
export const DEFAULT_PRODUCT_ICON_PATH = '/images/vendors/default.png';

/** Кастомное изображение: URL, путь или data URI (не имя иконки Lucide). */
export function isProductIconImageUrl(value) {
  if (!value || typeof value !== 'string') return false;
  const v = value.trim();
  if (!v) return false;
  return v.startsWith('/') || v.startsWith('http') || v.startsWith('https') || v.startsWith('data:');
}

/** Проверяет, является ли значение Lucide иконкой (не URL и не пустое). */
export function isLucideIcon(value) {
  if (!value || typeof value !== 'string') return false;
  const v = value.trim();
  if (!v) return false;
  // Lucide иконки - это слова без / : и других URL-символов
  return !v.startsWith('/') && !v.startsWith('http') && !v.startsWith('https') && !v.startsWith('data:') && v.length < 30;
}

/** Логотип вендора из API или calculator_config.vendor_info */
export function resolveVendorLogo(product) {
  if (!product) return null;
  const fromApi = (product.vendor_logo || '').trim();
  if (fromApi && isProductIconImageUrl(fromApi)) return fromApi;
  const fromCalc = (product.calculator_config?.vendor_info?.logo || '').trim();
  if (fromCalc && isProductIconImageUrl(fromCalc)) return fromCalc;
  return null;
}

/**
 * Src для карточки/героя решения.
 * Приоритет: image → icon (URL) → vendor logo → default
 */
export function getProductIconSrc(icon, image = null, vendorLogo = null) {
  if (image && isProductIconImageUrl(image)) {
    return image.trim();
  }
  if (icon && isProductIconImageUrl(icon)) {
    return icon.trim();
  }
  if (vendorLogo && isProductIconImageUrl(vendorLogo)) {
    return vendorLogo.trim();
  }
  return DEFAULT_PRODUCT_ICON_PATH;
}

/** Иконка решения с подстановкой логотипа вендора при отсутствии своей */
export function getProductIconSrcForProduct(product, vendorLogoOverride = null) {
  const vendorLogo = vendorLogoOverride || resolveVendorLogo(product);
  return getProductIconSrc(product?.icon, product?.image, vendorLogo);
}
